export const LogoMark = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 48 48" className={className} aria-hidden="true">
    <rect width="48" height="48" rx="13" fill="#0B1120" />
    <path d="M14 15.5 24 29.5 34 15.5" stroke="#FF5A36" strokeWidth="4.5" strokeLinecap="round" strokeLinejoin="round" fill="none" />
    <path d="M9 34.5c3-3 6-3 9 0s6 3 9 0 6-3 9 0 3 3 3 3" stroke="#fff" strokeWidth="3.2" strokeLinecap="round" fill="none" />
  </svg>
);

export const Logo = ({ compact = false }) => (
  <a href="#top" className="flex items-center gap-2.5" data-testid="logo" aria-label="Tenerife Excursions">
    <LogoMark />
    {!compact && (
      <span className="font-display leading-none">
        <span className="block text-[15px] font-bold tracking-tight text-[var(--ink)]">Tenerife</span>
        <span className="block text-[11px] font-semibold uppercase tracking-[0.22em] text-[var(--coral)]">Excursions</span>
      </span>
    )}
  </a>
);
